import React, { useState, useEffect } from 'react'
import { Trans, useTranslation, useI18next } from 'gatsby-plugin-react-i18next'
import { StaticImage } from 'gatsby-plugin-image'

function PersonalizedProgram() {
  const { t, i18n, language } = useI18next()
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const slideImages = [
    'https://res.cloudinary.com/vantagecircle/image/upload/v1743760472/VantageFit/2025/Group_482.png',
    'https://res.cloudinary.com/vantagecircle/image/upload/v1743760472/VantageFit/2025/Group_482.png',
    'https://res.cloudinary.com/vantagecircle/image/upload/v1743760472/VantageFit/2025/Group_482.png',
    'https://res.cloudinary.com/vantagecircle/image/upload/v1743760472/VantageFit/2025/Group_482.png',
    'https://res.cloudinary.com/vantagecircle/image/upload/v1743760472/VantageFit/2025/Group_482.png',
  ]

  return (
    <div className="prime-vf-page personalized-program">
      <section className="hero-bg position-relative">
        <div className="container custom_container pp-hero position-relative">
          <div className="row">
            <div className="col-12 col-md-6 d-flex flex-column justify-content-start align-items-centerc align-items-md-start pp-sec-hero h-100">
              <h1 className="text-center text-md-left">
                <Trans>
                  Personalized
                  <br />
                  Programs
                </Trans>
              </h1>
              <p className="text-center text-md-left mb-2 text-white">
                <Trans>Because every employee deserves their own path to wellness.</Trans>
              </p>
              <div className="pl-0 col-12 d-flex justify-content-start align-items-center mt-4">
                <a href="#form-partner" className="vfitcompanycta arrowbtn-img">
                  <Trans>Book a Demo</Trans>
                </a>
              </div>
            </div>
            {!isMobile ? (
              <div className="col-12 col-md-6 d-flex justify-content-end align-items-center">
                <div className="h-100 " style={{ maxHeight: '647px', overflow: 'hidden' }}>
                  <div className="animate-up d-flex justify-content-center">
                    <StaticImage
                      src="https://res.cloudinary.com/vantagecircle/image/upload/v1746533873/VantageFit/2025/webp-images/Strip.webp"
                      alt="img-1"
                      placeholder="blurred"
                      layout="constrained"
                      width={300}
                      transformOptions={{ quality: 80 }}
                    />
                    <StaticImage
                      src="https://res.cloudinary.com/vantagecircle/image/upload/v1746533873/VantageFit/2025/webp-images/Strip.webp"
                      alt="img-1"
                      placeholder="blurred"
                      layout="constrained"
                      width={300}
                      transformOptions={{ quality: 80 }}
                    />
                  </div>
                </div>
                <div className="h-100" style={{ maxHeight: '647px', overflow: 'hidden' }}>
                  <div className="animate-down d-flex justify-content-center">
                    <StaticImage
                      src="https://res.cloudinary.com/vantagecircle/image/upload/v1746533873/VantageFit/2025/webp-images/Strip.webp"
                      alt="img-1"
                      placeholder="blurred"
                      layout="constrained"
                      width={300}
                      transformOptions={{ quality: 80 }}
                    />
                    <StaticImage
                      src="https://res.cloudinary.com/vantagecircle/image/upload/v1746533873/VantageFit/2025/webp-images/Strip.webp"
                      alt="img-1"
                      placeholder="blurred"
                      layout="constrained"
                      width={300}
                      transformOptions={{ quality: 80 }}
                      className="mt-0"
                    />
                  </div>
                </div>
              </div>
            ) : null}
          </div>
          {!isMobile ? (
            <div style={{ position: 'absolute', bottom: '0', left: '50%', transform: 'translateX(-50%)', zIndex: '1' }}>
              <StaticImage
                src="https://res.cloudinary.com/vantagecircle/image/upload/v1746509626/VantageFit/2025/webp-images/bc293d5299dbb630213a5be0375683fd29b8ebbb.webp"
                alt="Hero Background"
                placeholder="blurred"
                layout="constrained"
                width={600}
                transformOptions={{ quality: 80 }}
              />
            </div>
          ) : null}
        </div>
      </section>
      <section className="position-relative section-padding one-stop">
        <div className="mb-0">
          <div className="d-flex m-d-block justify-content-between align-items-center container custom_container p0">
            <div className="col-12 col-md-5">
              <h2 className="py-2 text-center text-md-left">
                <Trans>What are Personalized Programs?</Trans>
              </h2>
              <p className="mt-3 mt-md-4 text-center text-md-left">
                <Trans>
                  Personalized programs are customized health and wellness solutions tailored to individual employee
                  needs. Unlike generic wellness initiatives, these programs adapt based on:
                </Trans>
              </p>
              <ul className="pricing-one-time-bullets pricing-standard-bullets">
                <li>
                  <Trans>Personal assessments</Trans>
                </li>
                <li>
                  <Trans>Employee preferences</Trans>
                </li>
                <li>
                  <Trans>Individual progress</Trans>
                </li>
              </ul>
            </div>
            {isMobile ? (
              <div className="d-flex justify-content-center">
                <StaticImage
                  src="https://res.cloudinary.com/vantagecircle/image/upload/v1744884376/VantageFit/2025/image.jpg"
                  formats={['auto', 'webp', 'avif']}
                  alt="Vantage Fit image"
                  placeholder="blurred"
                  layout="constrained"
                  width={600}
                  height={497}
                  transformOptions={{ quality: 80 }}
                />
              </div>
            ) : (
              <div className="d-flex justify-content-center">
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  width="100%"
                  height="auto"
                  loading="lazy"
                  decoding="async"
                  style={{ display: 'block', maxHeight: '550px', height: '100%' }}
                >
                  <source
                    src="https://res.cloudinary.com/vantagecircle/video/upload/v1744884094/VantageFit/2025/landing_page_UI_animation_2.mp4"
                    type="video/mp4"
                  />
                </video>
              </div>
            )}
          </div>
        </div>
      </section>
      <section className={`position-relative one-stop warn-sec ${isMobile ? 'mbl-bg-clr' : ''}`}>
        {!isMobile ? (
          <StaticImage
            src="https://res.cloudinary.com/vantagecircle/image/upload/v1744885225/VantageFit/2025/wwhy_traditional_wellness_fail-bg.png" // path to the image
            alt="Background image"
            placeholder="blurred"
            layout="fullWidth"
            formats={['auto', 'webp', 'avif']}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              zIndex: 1, // Ensure image is behind the content
            }}
          />
        ) : null}

        <div
          className="feat_pb0 mb-0 d-flex justify-content-center justify-content-md-end align-items-center"
          style={{ zIndex: 2, position: 'relative' }}
        >
          <div className="col-12 col-md-6 section-padding px-4 pl-md-5" style={{ backdropFilter: 'blur(60px)' }}>
            <h2 className="text-white text-center text-md-left">
              <Trans>
                Why Traditional Wellness <br /> Programs Fail?
              </Trans>
            </h2>
            <div className="mt-4">
              <p className="text-center text-md-left mb-0 text-white">
                <Trans>
                  Many companies invest in wellness initiatives, but most fail to engage <br /> employees effectively.
                  The common challenges include:
                </Trans>
              </p>
              <ul className="mt-5">
                <li className="text-left mb-5 text-white">
                  <Trans>
                    Traditional wellness programs are often generic and fall short <br /> on addressing the unique
                    health goal of the employee
                  </Trans>
                </li>
                <li className="text-left mb-5 text-white">
                  <Trans>
                    One-size-fits-all approaches that don’t <br /> address individual needs
                  </Trans>
                </li>
                <li className="text-left mb-0 text-white">
                  <Trans>
                    Traditional programs fail to track the real time progress of a <br /> health program and provide
                    valuable insights for improvement
                  </Trans>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="hero-bg section-padding hwitwrks">
        <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
          <div className="container">
            <h2 className="text-center text-white pt-0">
              <Trans>How It Works</Trans>
            </h2>
            <div className="row justify-content-around mt-5">
              <div className="col-12 col-lg-3 lg-img-bg mb-5 mb-md-0">
                <div className="league-content p-4">
                  <h4 className="text-white text-center text-lg-left">1</h4>
                  <p className=" text-white p-0 mb-2 text-center text-lg-left boldPara">
                    <Trans>Quick Assessment:</Trans>
                  </p>
                  <p className="hero-para font-weight-semibold no-br m-0" style={{ position: 'inherit', zIndex: '1' }}>
                    <Trans>Employees answer key health questions.</Trans>
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3 lg-img-bg arw2 mb-5 mb-md-0">
                <div className="league-content p-4">
                  <h4 className="text-white text-center text-lg-left">2</h4>
                  <p className="text-white p-0 mb-2 text-center text-lg-left boldPara">
                    <Trans>Program Activation:</Trans>
                  </p>
                  <p className="hero-para font-weight-semibold no-br m-0" style={{ position: 'inherit', zIndex: '1' }}>
                    <Trans>Personalized programs are generated instantly.</Trans>
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3 lg-img-bg arw2 mb-5 mb-md-0">
                <div className="league-content p-4">
                  <h4 className="text-white text-center text-lg-left">3</h4>
                  <p className=" text-white p-0 mb-2 text-center text-lg-left boldPara">
                    <Trans>Weekly Challenges:</Trans>
                  </p>
                  <p className="hero-para font-weight-semibold no-br m-0" style={{ position: 'inherit', zIndex: '1' }}>
                    <Trans>Engaging and fun tasks keep employees motivated.</Trans>
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3 lg-img-bg arw2 mb-5 mb-md-0">
                <div className="league-content p-4">
                  <h4 className="text-white text-center text-lg-left">4</h4>
                  <p className=" text-white p-0 mb-2 text-center text-lg-left boldPara">
                    <Trans>Progress Tracking:</Trans>
                  </p>
                  <p className="hero-para font-weight-semibold no-br m-0" style={{ position: 'inherit', zIndex: '1' }}>
                    <Trans>HRs get real-time insights on wellness impact</Trans>
                  </p>
                </div>
              </div>
            </div>
            <div className="row pt-5">
              <div className="col-12 col-md-6">
                <h2 className="py-2 text-white text-center text-md-left">
                  <Trans>
                    Programs Designed to <br /> Address Your Employees’ <br /> Biggest Health Challenges
                  </Trans>
                </h2>
                <p className="text-center text-md-left mb-0 text-white">
                  <Trans>
                    Every workplace is different, and so are its wellness needs. Our programs support multiple
                    dimensions of wellness, including:
                  </Trans>
                </p>
              </div>
              <div className="col-12 col-md-6 pr-0">
                <div className="h-100 w-100 d-flex justify-content-end align-items-center pt-5 pt-md-0">
                  <StaticImage
                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1744885225/VantageFit/2025/Programs_Designed_to_Address_Your_Employees_Biggest_Health_Challenges.png"
                    alt="ftimg"
                    placeholder="blurred"
                    layout="constrained"
                    width={583}
                    height={578}
                    transformOptions={{ quality: 80 }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="position-relative section-padding one-stop">
        <div className="row">
          <div className="col-12">
            <h1 className="text-black text-center pt-0">
              <Trans>Tailored Wellness in Action</Trans>
            </h1>
            <p className="text-center mb-0 text-black">
              <Trans>Supporting every employee’s path to better health.</Trans>
            </p>
          </div>
        </div>
      </section>
      <section className="bottom-feat-cta position-relative section-pdn-1 pt-8 feat_testi brad0">
        <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
          <div className="col-12">
            <h2 className="font-weight-semibold section-heading text-center no-br">
              <Trans>Let’s Build a Healthier, More Engaged Workforce Together</Trans>
            </h2>
            <p className="sub-para font-weight-normal text-center mb-5 text-white">
              <Trans>
                Join companies worldwide that have transformed their workplace culture with Vantage Fit’s Personalized
                Programs.
              </Trans>
            </p>
            <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
              <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                <Trans>Book a Demo</Trans>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default PersonalizedProgram
